import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

const home = () => import( /* webpackChunkName: "home" */ './views/home.vue');
const about = () => import( /* webpackChunkName: "about" */ './views/about.vue');
const contacts = () => import( /* webpackChunkName: "contacts" */ './views/contacts.vue');
const news = () => import( /* webpackChunkName: "news" */ './views/news.vue');
const newsCard = () => import( /* webpackChunkName: "news" */ '@/components/news-page/news-card.vue');
const vacancy = () => import( /* webpackChunkName: "vacancy" */ './views/vacancy.vue');
const video = () => import( /* webpackChunkName: "video" */ './views/video.vue');
const construction = () => import( /* webpackChunkName: "construction" */ './views/construction.vue');
const design = () => import( /* webpackChunkName: "design" */ './views/design.vue');
const projectsPage = () => import( /* webpackChunkName: "projectPage" */ './views/projects.vue');
const projectCard = () => import( /* webpackChunkName: "projects" */ '@/components/projects/project-card.vue');

const NotFound = () => import( /* webpackChunkName: "notFound" */ './views/404.vue');
const error = () => import( /* webpackChunkName: "error" */ './views/error.vue');



Vue.use(Router)


const router = new Router({
	mode: 'history',
	hash: false,
	scrollBehavior (to, from, savedPosition) {
		return new Promise((resolve, reject) => {
		// setTimeout(() => {
			if (to.hash) {
				// console.log(to.hash, 'adasdasd')
				return resolve({ 
					selector: to.hash,
					offset: { x: 0, y: 75 }
				});
			} else if (savedPosition) {
				// console.log(savedPosition, 'adasdasdas')
				return resolve(savedPosition);
			} else {
				// console.log('3')
				// return { x: 0, y: 0 };
				resolve(document.getElementById("app").scrollIntoView({ behavior: "instant" }));
				// resolve(document.getElementById("app").scrollIntoView({ behavior: "smooth" }));
			} 
		// }, 1200);
		});
	},
	routes: [
		{
			path: '/',
			name: 'home',
			component: home,
			meta: { 
				crumbs: '/Главная',
				path: '/'
			}
		},
		{
			path: '/about',
			name: 'about',
			component: about,
		},
		{
			path: '/news',
			name: 'news',
			component: news,
		},
		{
			path: '/news/:id',
			name: 'news-card',
			component: newsCard,
		},
		{
			path: '/vacancy',
			name: 'vacancy',
			component: vacancy,
		},
		{
			path: '/contacts',
			name: 'contacts',
			component: contacts,
		},
		{
			path: '/construction',
			name: 'construction',
			component: construction,
		},
		{
			path: '/design',
			name: 'design',
			component: design,
		},
		{
			path: '/video',
			name: 'video',
			component: video,
			meta: { 
				crumbs: '/Видео',
				path: '/Video'
			}
		},
		{
			path: '/projects',
			name: 'projects',
			redirect: {name: 'built'},
		},
		{
			path: '/projects/built',
			name: 'built',
			component: projectsPage,
		},

		{
			path: '/projects/construction',
			name: 'construction',
			component: projectsPage,
		},

		{
			path: '/projects/international',
			name: 'international',
			component: projectsPage,
		},

		{
			path: '/activites',
			name: 'activites',
			redirect: {name: 'construction'},
		},


		// {
		// 	path: '/projects/promising',
		// 	name: 'promising',
		// 	component: projectsPage,
		// },
		{
			path: '/projects/:pageID/:id',
			name: 'project-card',
			component: projectCard,
		},
		{ 
            path: '/404', 
            name: '404', 
            component: NotFound, 
        }, 
        { 
            path: '*', 
            redirect: '/404'
		},
		{ 
            path: '/error', 
            name: 'error', 
            component: error, 
		},
		{
			path: '/partners',
			beforeEnter() {window.open('http://portal.bazis.kz', '_blank',)}
		},
		// redirect for 2gis link
		{
			path: '/obekty_na_prodazhu',
			beforeEnter() {location.href = 'https://sales.bazis.kz/?utm_source=2gisLink'},
		},
	]
})

router.beforeResolve((to, from, next) => {
	if (to.name) {
		store.commit('setPageName', to.name);
		// Закрываем мобильное меню
		store.commit('Open_Sendwich', false);
		document.getElementsByTagName('body')[0].classList.remove('overlay-open');
	}
	if (to.name == 'activites') {
		next('/construction');
	}
  	if (to.name == 'partners') {
		// console.log(to.name)
		window.open('https://portal.bazis.kz');
		next(from);
	} 
  next()
})

export default router
